module.exports = __webpack_public_path__ + "img/product_46.f76fd76.webp";